<template>
  <RevButtonBase
    :aria-label="COMPANY_NAME"
    :to="resolveLocalizedRoute({ name: HOME })"
    :tracking="{ name: 'logo', zone: 'header' }"
  >
    <RevIllustration
      :alt="COMPANY_NAME"
      :decoding
      :height="34"
      image-class-names="w-auto h-full [.mood-inverse_&]:brightness-0 [.mood-inverse_&]:invert"
      :loading
      src="/img/header/Logo.svg"
      :width="300"
    />
  </RevButtonBase>
</template>

<script setup lang="ts">
import { useRouteLocationWithLocale, useRuntimeConfig } from '#imports'

import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevIllustration } from '@ds/components/Illustration'

import { HOME } from '~/scopes/home/route-names'

const { decoding = 'sync', loading = 'lazy' } = defineProps<{
  decoding?: 'auto' | 'sync' | 'async'
  loading?: 'eager' | 'lazy'
}>()

const runtimeConfig = useRuntimeConfig()
const resolveLocalizedRoute = useRouteLocationWithLocale()
const { COMPANY_NAME } = runtimeConfig.public
</script>
